const steps = [
  {
    target: ".ninedot",
    contentTitle: "Quick Menu",
    contentText:
      "Quickly access the Vortex workspace features from any page of the workspace",
  },
  {
    target: ".applytodw",
    contentTitle: "Apply to Data Warehouse",
    contentText:
      "View the current running configuration, apply data to the warehouse and access history for the current workspace",
  },
];

const stepsData1 = steps.map(({ target, contentTitle, contentText }) => ({
  target,
  content: (
    <div>
      <h3 style={{ marginBottom: "15px" }}>
        <strong>{contentTitle}</strong>
      </h3>
      <p>{contentText}</p>
    </div>
  ),
}));

export default stepsData1;
